"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ata = exports.sendAndConfirmStreamRawTransaction = exports.signAllTransactionWithRecipients = exports.isSignerWallet = exports.getProgramAccounts = exports.formatDecodedStream = exports.decodeStream = void 0;
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var bn_js_1 = __importDefault(require("bn.js"));
var bs58_1 = __importDefault(require("bs58"));
var layout_1 = require("./layout");
var contractUtils_1 = require("../common/contractUtils");
var decoder = new TextDecoder("utf-8");
var LE = "le"; //little endian
var decodeStream = function (buf) {
    var raw = layout_1.streamLayout.decode(buf);
    return {
        magic: new bn_js_1.default(raw.magic, LE),
        version: new bn_js_1.default(raw.version, LE),
        createdAt: new bn_js_1.default(raw.created_at, LE),
        withdrawnAmount: new bn_js_1.default(raw.withdrawn_amount, LE),
        canceledAt: new bn_js_1.default(raw.canceled_at, LE),
        end: new bn_js_1.default(raw.end_time, LE),
        lastWithdrawnAt: new bn_js_1.default(raw.last_withdrawn_at, LE),
        sender: new web3_js_1.PublicKey(raw.sender),
        senderTokens: new web3_js_1.PublicKey(raw.sender_tokens),
        recipient: new web3_js_1.PublicKey(raw.recipient),
        recipientTokens: new web3_js_1.PublicKey(raw.recipient_tokens),
        mint: new web3_js_1.PublicKey(raw.mint),
        escrowTokens: new web3_js_1.PublicKey(raw.escrow_tokens),
        streamflowTreasury: new web3_js_1.PublicKey(raw.streamflow_treasury),
        streamflowTreasuryTokens: new web3_js_1.PublicKey(raw.streamflow_treasury_tokens),
        streamflowFeeTotal: new bn_js_1.default(raw.streamflow_fee_total, LE),
        streamflowFeeWithdrawn: new bn_js_1.default(raw.streamflow_fee_withdrawn, LE),
        streamflowFeePercent: new bn_js_1.default(raw.streamflow_fee_percent, LE),
        partnerFeeTotal: new bn_js_1.default(raw.partner_fee_total, LE),
        partnerFeeWithdrawn: new bn_js_1.default(raw.partner_fee_withdrawn, LE),
        partnerFeePercent: new bn_js_1.default(raw.partner_fee_percent, LE),
        partner: new web3_js_1.PublicKey(raw.partner),
        partnerTokens: new web3_js_1.PublicKey(raw.partner_tokens),
        start: new bn_js_1.default(raw.start_time, LE),
        depositedAmount: new bn_js_1.default(raw.net_amount_deposited, LE),
        period: new bn_js_1.default(raw.period, LE),
        amountPerPeriod: new bn_js_1.default(raw.amount_per_period, LE),
        cliff: new bn_js_1.default(raw.cliff, LE),
        cliffAmount: new bn_js_1.default(raw.cliff_amount, LE),
        cancelableBySender: Boolean(raw.cancelable_by_sender),
        cancelableByRecipient: Boolean(raw.cancelable_by_recipient),
        automaticWithdrawal: Boolean(raw.automatic_withdrawal),
        transferableBySender: Boolean(raw.transferable_by_sender),
        transferableByRecipient: Boolean(raw.transferable_by_recipient),
        canTopup: Boolean(raw.can_topup),
        name: decoder.decode(raw.stream_name),
        withdrawFrequency: new bn_js_1.default(raw.withdraw_frequency, LE),
        closed: Boolean(raw.closed),
        currentPauseStart: new bn_js_1.default(raw.current_pause_start, LE),
        pauseCumulative: new bn_js_1.default(raw.pause_cumulative, LE),
        lastRateChangeTime: new bn_js_1.default(raw.last_rate_change_time, LE),
        fundsUnlockedAtLastRateChange: new bn_js_1.default(raw.funds_unlocked_at_last_rate_change, LE),
    };
};
exports.decodeStream = decodeStream;
// DeprecationWarning: This object will be deprecated starting from the version 4.0.0. Use
// types/Contract instead
var formatDecodedStream = function (stream) {
    var _a;
    var resp = {
        magic: stream.magic.toNumber(),
        version: stream.version.toNumber(),
        createdAt: stream.createdAt.toNumber(),
        withdrawnAmount: stream.withdrawnAmount,
        canceledAt: stream.canceledAt.toNumber(),
        end: stream.end.toNumber(),
        lastWithdrawnAt: stream.lastWithdrawnAt.toNumber(),
        sender: stream.sender.toBase58(),
        senderTokens: stream.senderTokens.toBase58(),
        recipient: stream.recipient.toBase58(),
        recipientTokens: stream.recipientTokens.toBase58(),
        mint: stream.mint.toBase58(),
        escrowTokens: stream.escrowTokens.toBase58(),
        streamflowTreasury: stream.streamflowTreasury.toBase58(),
        streamflowTreasuryTokens: stream.streamflowTreasuryTokens.toBase58(),
        streamflowFeeTotal: stream.streamflowFeeTotal,
        streamflowFeeWithdrawn: stream.streamflowFeeWithdrawn,
        streamflowFeePercent: stream.streamflowFeePercent.toNumber(),
        partnerFeeTotal: stream.partnerFeeTotal,
        partnerFeeWithdrawn: stream.partnerFeeWithdrawn,
        partnerFeePercent: stream.partnerFeePercent.toNumber(),
        partner: stream.partner.toBase58(),
        partnerTokens: (_a = stream.partnerTokens) === null || _a === void 0 ? void 0 : _a.toBase58(),
        start: stream.start.toNumber(),
        depositedAmount: stream.depositedAmount,
        period: stream.period.toNumber(),
        amountPerPeriod: stream.amountPerPeriod,
        cliff: stream.cliff.toNumber(),
        cliffAmount: stream.cliffAmount,
        cancelableBySender: stream.cancelableBySender,
        cancelableByRecipient: stream.cancelableByRecipient,
        automaticWithdrawal: stream.automaticWithdrawal,
        transferableBySender: stream.transferableBySender,
        transferableByRecipient: stream.transferableByRecipient,
        canTopup: stream.canTopup,
        name: stream.name,
        withdrawalFrequency: stream.withdrawFrequency.toNumber(),
        closed: stream.closed,
        currentPauseStart: stream.currentPauseStart.toNumber(),
        pauseCumulative: stream.pauseCumulative,
        lastRateChangeTime: stream.lastRateChangeTime.toNumber(),
        fundsUnlockedAtLastRateChange: stream.fundsUnlockedAtLastRateChange,
        type: (0, contractUtils_1.buildStreamType)(stream),
        unlocked: function () {
            return new bn_js_1.default(0);
        },
        withdrawn: function () {
            return new bn_js_1.default(0);
        }, //phantom method to preserve partial support of this object
    };
    return resp;
};
exports.formatDecodedStream = formatDecodedStream;
/**
 * Wrapper function for Solana web3 getProgramAccounts with slightly better call interface
 * @param {Connection} connection - Solana web3 connection object.
 * @param {PublicKey} wallet - PublicKey to compare against.
 * @param {number} offset - Offset of bits of the PublicKey in the account binary.
 * @param {PublicKey} programId - Solana program ID.
 * @return {Promise<Account[]>} - Array of resulting accounts.
 */
function getProgramAccounts(connection, wallet, offset, programId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, connection === null || connection === void 0 ? void 0 : connection.getProgramAccounts(programId, {
                    filters: [
                        {
                            memcmp: {
                                offset: offset,
                                bytes: wallet.toBase58(),
                            },
                        },
                    ],
                })];
        });
    });
}
exports.getProgramAccounts = getProgramAccounts;
/**
 * Utility function to check if the transaction initiator is a KeyPair or a Wallet object
 * @param {Keypair | SignerWalletAdapter} walletOrKeypair - Wallet or Keypair in question
 * @return {boolean} - Returns true if parameter is a Wallet.
 */
function isSignerWallet(walletOrKeypair) {
    return walletOrKeypair.signTransaction !== undefined;
}
exports.isSignerWallet = isSignerWallet;
/**
 * Sign passed BatchItems with wallet request or KeyPair
 * @param {Keypair | SignerWalletAdapter} sender - Wallet or Keypair of sendin account
 * @param {BatchItem[]} items - Multiple recipient contracts split into separate items
 * @return {BatchItem[]} - Returns items with signatures.
 */
function signAllTransactionWithRecipients(sender, items) {
    return __awaiter(this, void 0, void 0, function () {
        var isKeypair, isWallet, signedTxs_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isKeypair = sender instanceof web3_js_1.Keypair;
                    isWallet = isSignerWallet(sender);
                    if (!isKeypair) return [3 /*break*/, 1];
                    return [2 /*return*/, items.map(function (t) {
                            t.tx.partialSign(sender);
                            return { tx: t.tx, recipient: t.recipient };
                        })];
                case 1:
                    if (!isWallet) return [3 /*break*/, 3];
                    return [4 /*yield*/, sender.signAllTransactions(items.map(function (t) { return t.tx; }))];
                case 2:
                    signedTxs_1 = _a.sent();
                    return [2 /*return*/, items.map(function (item, index) { return (__assign(__assign({}, item), { tx: signedTxs_1[index] })); })];
                case 3: 
                // If signer is not passed
                return [2 /*return*/, []];
            }
        });
    });
}
exports.signAllTransactionWithRecipients = signAllTransactionWithRecipients;
/**
 * Sign passed BatchItems with wallet request or KeyPair
 * @param {Connection} connection - Solana web3 connection object.
 * @param {BatchItem} batchItem - Signed transaction ready to be send.
 * @return {Promise<BatchItemResult>} - Returns settled transaction item
 */
function sendAndConfirmStreamRawTransaction(connection, batchItem) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var rawTx, _c, lastValidBlockHeight, signature, recentBlockhash, confirmationStrategy, completedTxSignature, error_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    rawTx = batchItem.tx.serialize();
                    _c = batchItem.tx, lastValidBlockHeight = _c.lastValidBlockHeight, signature = _c.signature, recentBlockhash = _c.recentBlockhash;
                    if (!lastValidBlockHeight || !signature || !recentBlockhash)
                        throw { recipient: batchItem.recipient, error: "no recent blockhash" };
                    confirmationStrategy = {
                        lastValidBlockHeight: lastValidBlockHeight,
                        signature: bs58_1.default.encode(signature),
                        blockhash: recentBlockhash,
                    };
                    return [4 /*yield*/, (0, web3_js_1.sendAndConfirmRawTransaction)(connection, rawTx, confirmationStrategy)];
                case 1:
                    completedTxSignature = _d.sent();
                    return [2 /*return*/, __assign(__assign({}, batchItem), { signature: completedTxSignature })];
                case 2:
                    error_1 = _d.sent();
                    throw {
                        recipient: batchItem.recipient,
                        error: (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.error) !== null && _a !== void 0 ? _a : error_1 === null || error_1 === void 0 ? void 0 : error_1.message) !== null && _b !== void 0 ? _b : error_1.toString(),
                    };
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.sendAndConfirmStreamRawTransaction = sendAndConfirmStreamRawTransaction;
/**
 * Shorthand call signature for getAssociatedTokenAddress, with allowance for address to be offCurve
 * @param {PublicKey} mint - SPL token Mint address.
 * @param {PublicKey} owner - Owner of the Associated Token Address
 * @return {Promise<PublicKey>} - Associated Token Address
 */
function ata(mint, owner) {
    return (0, spl_token_1.getAssociatedTokenAddress)(mint, owner, true);
}
exports.ata = ata;
